import convert from "convert-units";
import { coins_units, units_8 } from "../constants.js";
import { convertUnits } from "./convert.js";

//Codigos que se ven en los formularios
export const waterCodes = {
  water_domestic_municipal_network: "Agu1",
  municipal_network_water_production: "Agu2",
  combined_municipal_network_water: "Agu3",
  water_cost_domestic_municipal_network: "Agu4",
  water_cost_municipal_network_production: "Agu5",
  water_cost_combined_municipal_network: "Agu6",
  domestic_groundwater: "Agu7",
  groundwater_production: "Agu8",
  groundwater_combined: "Agu9",
  domestic_groundwater_cost: "Agu10",
  groundwater_production_cost: "Agu11",
  groundwater_combined_cost: "Agu12",
  rainwater: "Agu13",
  surface_water: "Agu14",
  //cost_surface_water: "Agu15",
  distilled_water: "Agu15",
  reused_water: "Agu16",
  recycled_water: "Agu17",
  steam_condensed_water: "Agu18",
};

//Codigos de los indicadores que se ven en el dashboard
export const waterKPIsCodes = {
  water_domestic_municipal_network_kpis: "KPIagu1",
  municipal_network_water_production_kpis: "KPIagu2",
  // combined_municipal_network_water_kpis: "KPIagu3",
  domestic_groundwater_kpis: "KPIagu4",
  groundwater_production_kpis: "KPIagu5",
  // groundwater_combined_kpis: "KPIagu6",
  rainwater_kpis: "KPIagu7",
  surface_water_kpis: "KPIagu8",
  recycled_water_kpis: "KPIagu9",
  reused_water_kpis: "KPIagu10",
  steam_condensed_water_kpis: "KPIagu11",
  total_water_production_kpis: "KPIagu12",
  total_domestic_water_kpis: "KPIagu13",
  combined_total_water_kpis: "KPIagu14",
  total_production_water_per_unit_kpis: "KPIagu15", // Agua total Producción / unidad
  total_domestic_water_per_employee_kpis: "KPIagu16", // Agua total Doméstica / empleado
  //total_combined_water_per_unit_kpis: "KPIagu17", // Agua total combinada / unidad

  total_production_water_cost_per_unit_kpis: "KPIagu18", // Costo agua total Producción / unidad
  total_domestic_water_cost_per_employee_kpis: "KPIagu19", // Costo agua total Doméstica / empleado
  total_combined_water_cost_per_unit_kpis: "KPIagu20", // Costo agua total combinada / unidad

  total_water_consumption_kpis: "KPIagu21", // Consumo de Agua Total
};

const firstValidUnit = (...units) =>
  units.find((u) => typeof u === "string" && u.trim() !== "") ?? null;

//En base al valor del campo / key devuelve el valor correspondiente de acuerdo al año es de tipo {total, unit}
export function waterFormulasIndicators(field, year, data, baseline, cantW) {
  switch (field) {
    case "municipal_network_water_production_kpis":
      return {
        total:
          data["municipal_network_water_production"]?.[year].total / baseline,
        unit: data["municipal_network_water_production"]?.[year].unit,
      };
    case "water_domestic_municipal_network_kpis":
      return {
        total: data["water_domestic_municipal_network"]?.[year].total / cantW,
        unit: data["water_domestic_municipal_network"]?.[year].unit,
      };
    // case "combined_municipal_network_water_kpis":
    //   return {
    //     total:
    //       data["combined_municipal_network_water"]?.[year].total / baseline,
    //     unit: data["combined_municipal_network_water"]?.[year].unit,
    //   };
    case "groundwater_production_kpis":
      return {
        total: data["groundwater_production"]?.[year].total / baseline,
        unit: data["groundwater_production"]?.[year].unit,
      };
    case "domestic_groundwater_kpis":
      return {
        total: data["domestic_groundwater"]?.[year].total / cantW,
        unit: data["domestic_groundwater"]?.[year].unit,
      };
    // case "groundwater_combined_kpis":
    //   return {
    //     total: data["groundwater_combined"]?.[year].total / baseline,
    //     unit: data["groundwater_combined"]?.[year].unit,
    //   };
    case "rainwater_kpis":
      return {
        total: data["rainwater"]?.[year].total / cantW,
        unit: data["rainwater"]?.[year].unit,
      };
    case "surface_water_kpis":
      return {
        total: data["surface_water"]?.[year].total / baseline,
        unit: data["surface_water"]?.[year].unit,
      };
    case "recycled_water_kpis":
      return {
        total: data["recycled_water"]?.[year].total / baseline,
        unit: data["recycled_water"]?.[year].unit,
      };
    case "reused_water_kpis":
      return {
        total: data["reused_water"]?.[year].total / baseline,
        unit: data["reused_water"]?.[year].unit,
      };
    case "steam_condensed_water_kpis":
      return {
        total: data["steam_condensed_water"]?.[year].total / baseline,
        unit: data["steam_condensed_water"]?.[year].unit,
      };
    case "total_water_production_kpis": {
      // ✅ Solo incluir fuentes primarias de agua industrial
      const keys = [
        "municipal_network_water_production",
        "groundwater_production",
        "rainwater",
        "surface_water",
        // ❌ NO incluir agua procesada/reciclada (ya fue contada en fuentes primarias):
        "distilled_water", // Agua destilada (agua ya tratada)
        "reused_water", // Agua reutilizada (ya contada antes)
        "recycled_water", // Agua reciclada (ya contada antes)
        "steam_condensed_water", // Agua condensada (agua reciclada del proceso)
      ];

      // ✅ Buscar la unidad del primer campo que tenga valor > 0 (campo activo)
      let unit = null;
      for (const k of keys) {
        const registro = data[k]?.[year];
        if (registro && registro.total > 0 && registro.unit) {
          unit = registro.unit;
          break;
        }
      }

      // Si no hay campos activos, buscar cualquier unidad existente como fallback
      if (!unit) {
        unit = keys
          .map((k) => data[k]?.[year]?.unit)
          .find((u) => u !== undefined && u !== null && u !== "");
      }

      return {
        total: addData(keys, year, data, unit),
        unit,
      };
    }
    case "total_domestic_water_kpis": {
      const keys2 = [
        "water_domestic_municipal_network",
        "domestic_groundwater",
      ];

      // ✅ Buscar la unidad del primer campo que tenga valor > 0 (campo activo)
      let unit = null;
      for (const k of keys2) {
        const registro = data[k]?.[year];
        if (registro && registro.total > 0 && registro.unit) {
          unit = registro.unit;
          break;
        }
      }

      // Si no hay campos activos, buscar cualquier unidad existente como fallback
      if (!unit) {
        unit = keys2.map((k) => data[k]?.[year]?.unit).find(Boolean);
      }

      return {
        total: addData(keys2, year, data, unit),
        unit,
      };
    }
    case "combined_total_water_kpis": {
      const keys3 = [
        "combined_municipal_network_water",
        "groundwater_combined",
      ];

      // ✅ Buscar la unidad del primer campo que tenga valor > 0 (campo activo)
      let unit = null;
      for (const k of keys3) {
        const registro = data[k]?.[year];
        if (registro && registro.total > 0 && registro.unit) {
          unit = registro.unit;
          break;
        }
      }

      // Si no hay campos activos, buscar cualquier unidad existente como fallback
      if (!unit) {
        unit = keys3.map((k) => data[k]?.[year]?.unit).find(Boolean);
      }

      return {
        total: addData(keys3, year, data, unit),
        unit,
      };
    }

    case "total_production_water_per_unit_kpis":
      return {
        total:
          waterFormulasIndicators("total_water_production_kpis", year, data)
            .total / baseline,
        unit: data["total_water_production_kpis"]?.[year].unit,
      };

    case "total_domestic_water_per_employee_kpis":
      return {
        total:
          waterFormulasIndicators("total_domestic_water_kpis", year, data)
            .total / cantW,
        unit: data["total_domestic_water_kpis"]?.[year].unit,
      };

    case "total_production_water_cost_per_unit_kpis": {
      const keys6 = [
        "water_cost_municipal_network_production",
        "groundwater_production_cost",
      ];

      const unit = firstValidUnit(
        data?.water_cost_municipal_network_production?.[year]?.unit,
        data?.groundwater_production_cost?.[year]?.unit,
      );

      //console.log("unit",unit, data?.groundwater_production_cost?.[year]?.unit)
      return {
        total: addData(keys6, year, data, unit) / baseline,
        unit,
      };
    }

    case "total_domestic_water_cost_per_employee_kpis": {
      const keys7 = [
        "water_cost_domestic_municipal_network",
        "domestic_groundwater_cost",
      ];

      // Tomar la primera unidad válida
      const unit = firstValidUnit(
        data?.water_cost_domestic_municipal_network?.[year]?.unit,
        data?.domestic_groundwater_cost?.[year]?.unit,
      );

      const total = unit ? addData(keys7, year, data, unit) / cantW : 0;

      return {
        total,
        unit: unit ?? null,
      };
    }

    case "total_combined_water_cost_per_unit_kpis": {
      const keys8 = [
        "water_cost_combined_municipal_network",
        "groundwater_combined_cost",
      ];

      // Tomar la primera unidad válida
      const unit = firstValidUnit(
        data?.water_cost_combined_municipal_network?.[year]?.unit,
        data?.groundwater_combined_cost?.[year]?.unit,
      );

      return {
        total: addData(keys8, year, data, unit) / baseline,
        unit,
      };
    }

    case "total_water_consumption_kpis": {
      // ✅ Suma los KPIs de agua: producción + doméstica + combinada
      const productionKpi = waterFormulasIndicators(
        "total_water_production_kpis",
        year,
        data,
        baseline,
        cantW,
      );
      const domesticKpi = waterFormulasIndicators(
        "total_domestic_water_kpis",
        year,
        data,
        baseline,
        cantW,
      );
      const combinedKpi = waterFormulasIndicators(
        "combined_total_water_kpis",
        year,
        data,
        baseline,
        cantW,
      );

      // Crear objeto temporal con estructura compatible con addData
      const kpisData = {
        total_water_production_kpis: { [year]: productionKpi },
        total_domestic_water_kpis: { [year]: domesticKpi },
        combined_total_water_kpis: { [year]: combinedKpi },
      };

      const kpisKeys = [
        "total_water_production_kpis",
        "total_domestic_water_kpis",
        "combined_total_water_kpis",
      ];

      // Usar la primera unidad válida de los KPIs
      const unit =
        productionKpi?.unit || domesticKpi?.unit || combinedKpi?.unit || null;

      const total = addData(kpisKeys, year, kpisData, unit);

      return {
        total,
        unit,
      };
    }

    default:
      return false;
  }
}

function addData(keys, year, data, unitSelected) {
  let suma = 0;

  for (let clave of keys) {
    const registro = data?.[clave]?.[year];
    //console.log(clave, registro);
    // ⚠️ Si no hay registro o valor, continuar
    if (!registro || registro.total == null || isNaN(registro.total)) continue;

    const valor = Number(registro.total) || 0;

    // ⚠️ Si el valor es 0, no intentar sumarlo
    if (valor === 0) continue;

    const unidad = registro.unit || unitSelected; // usa unidad destino si no tiene propia

    // ⚠️ Si la unidad no es válida (null, undefined, ""), saltar este registro
    if (!unidad || unidad === "" || unidad === null || unidad === undefined) {
      console.warn(
        `⚠️ Campo ${clave} año ${year}: valor ${valor} pero sin unidad válida, saltando...`,
      );
      continue;
    }

    try {
      // ✅ convierte solo si la función soporta ambas unidades
      const convertido = convertUnits(valor, unidad, unitSelected);
      //console.log(clave, convertido)
      suma += !isNaN(convertido) ? convertido : 0;
    } catch (err) {
      // ⚠️ si falla la conversión, usa el valor directo
      console.warn(
        `⚠️ Error convirtiendo ${clave} de ${unidad} a ${unitSelected}, usando valor directo`,
      );
      suma += valor;
    }
  }

  return suma;
}

//Determina las unidades utilizadas de acuerdo a cada campo/key ver boceto con unidades
export const determineWaterUnits = (value) => {
  if (
    value === "water_cost_municipal_network_production" ||
    value === "water_cost_domestic_municipal_network" ||
    value === "water_cost_combined_municipal_network" ||
    value === "cost_surface_water" ||
    value === "domestic_groundwater_cost" ||
    value === "groundwater_production_cost" ||
    value === "groundwater_combined_cost" ||
    value === "total_production_cost_production_kpis" ||
    value === "total_domestic_water_cost_kpis" ||
    value === "combined_total_water_cost_kpis"
  ) {
    return coins_units.map((unit) => ({ ...unit, text: unit.name }));
  } else {
    return units_8.map((unit) => ({ ...unit, text: unit.name }));
  }
};

// export function convertUnitsWater(valor, unidadOrigen, unidadDestino) {
//   // Convertir de Litros a otras unidades
//   if (unidadOrigen === "l") {
//     if (unidadDestino === "m3") {
//       return valor / 1000; // 1 L = 0.001 m³
//     } else if (unidadDestino === "galon") {
//       return valor / 3.78541; // 1 L = 0.264172 gal (EE.UU.)
//     }
//   }

//   // Convertir de Metros cúbicos a otras unidades
//   if (unidadOrigen === "m3") {
//     if (unidadDestino === "l") {
//       return valor * 1000; // 1 m³ = 1000 L
//     } else if (unidadDestino === "galon") {
//       return valor * 264.172; // 1 m³ = 264.172 gal (EE.UU.)
//     }
//   }

//   // Convertir de Galones (EE.UU.) a otras unidades
//   if (unidadOrigen === "galon") {
//     if (unidadDestino === "l") {
//       return valor * 3.78541; // 1 gal (EE.UU.) = 3.78541 L
//     } else if (unidadDestino === "m3") {
//       return valor / 264.172; // 1 gal (EE.UU.) = 0.00378541 m³
//     }
//   }

//   // Convertir de Galones (imperial) a otras unidades
//   if (unidadOrigen === "galImperial") {
//     if (unidadDestino === "l") {
//       return valor * 4.54609; // 1 gal (imperial) = 4.54609 L
//     } else if (unidadDestino === "m3") {
//       return valor / 219.969; // 1 gal (imperial) = 0.00454609 m³
//     } else if (unidadDestino === "gal") {
//       return valor / 1.20095; // 1 gal (imperial) = 0.832674 gal (EE.UU.)
//     }
//   }

//   return "Conversión no válida";
// }

// export const convertUnitsFinal = (value, unita, unitb) => {
//   try {
//     const esMoneda = (unidad) =>
//       coins_units.some((moneda) => moneda.value === unidad);

//     // Si las unidades de origen y destino son iguales, no hacer conversión
//     if (!value) {
//       return 0;
//     } else {
//       if (unita === unitb) {
//         return value;
//       }

//       // Si estamos trabajando con monedas, aplicamos la conversión de divisas
//       if (esMoneda(unita) && esMoneda(unitb)) {
//         // Lógica de conversión de monedas (puedes usar una API o tasas fijas)
//         // const tasaDeCambio = obtenerTasaDeCambio(unita, unitb); // Esta función debe obtener la tasa de cambio
//         // if (!tasaDeCambio) {
//         //   console.error("No se pudo obtener la tasa de cambio.");
//         //   return null; // Si no se puede obtener la tasa, retornar null
//         ////}
//         //return value * tasaDeCambio; // Multiplicamos el valor por la tasa de cambio
//         return value;
//       }
//       const result = convert(value).from(unita).to(unitb);
//       // Si la conversión falla y devuelve NaN, vamos a intentar con la función personalizada
//       if (isNaN(result)) {
//         //console.log('La librería convert-units no pudo realizar la conversión. Intentando con la función personalizada...');
//         return value;
//       }
//       return result;
//     }
//   } catch (error) {
//     try {
//       const result2 = convertUnitsWater(value, unita, unitb);
//       return result2;
//     } catch {
//       // Si ocurre un error en la librería o en la función personalizada, lo capturamos
//       console.error(`Error de conversión: ${error.message}`);
//       return null; // Retornamos null si hay un error
//     }
//   }
// };

// Tabla de conversiones base (todas respecto a litros)
const waterConversion = {
  l: 1,
  m3: 1000, // 1 m³ = 1000 L
  galon: 3.78541, // 1 gal (EE.UU.) = 3.78541 L
  galImperial: 4.54609, // 1 gal (imperial) = 4.54609 L
};

export function convertUnitsWater(valor, unidadOrigen, unidadDestino) {
  unidadOrigen = unidadOrigen?.toLowerCase?.() ?? unidadOrigen;
  unidadDestino = unidadDestino?.toLowerCase?.() ?? unidadDestino;
  if (!waterConversion[unidadOrigen] || !waterConversion[unidadDestino]) {
    return "Conversión no válida";
  }

  // Convertimos primero a litros
  const valorEnLitros = valor * waterConversion[unidadOrigen];

  // Luego de litros a la unidad destino
  const resultado = valorEnLitros / waterConversion[unidadDestino];

  return resultado;
}

// Función general de conversión
export const convertUnitsFinal = (value, unita, unitb) => {
  try {
    if (!value) return 0; // Si el valor es null o 0

    // Si las unidades son iguales, no hace conversión
    if (unita === unitb) return value;

    const esMoneda = (unidad) =>
      coins_units.some((moneda) => moneda.value === unidad);

    // Si estamos trabajando con monedas, aplicamos la conversión de divisas
    if (esMoneda(unita) && esMoneda(unitb)) {
      // Lógica de conversión de monedas (puedes usar una API o tasas fijas)
      // const tasaDeCambio = obtenerTasaDeCambio(unita, unitb); // Esta función debe obtener la tasa de cambio
      // if (!tasaDeCambio) {
      //   console.error("No se pudo obtener la tasa de cambio.");
      //   return null; // Si no se puede obtener la tasa, retornar null
      ////}
      //return value * tasaDeCambio; // Multiplicamos el valor por la tasa de cambio
      return value;
    }

    // Intentamos conversión con la librería 'convert-units'
    let result = convert(value).from(unita).to(unitb);
    if (isNaN(result)) {
      // Si falla, usamos la función personalizada
      result = convertUnitsWater(value, unita, unitb);
    }
    return result;
  } catch (error) {
    //console.error(`Error de conversión: ${error.message}`, value, unita, unitb);
    // Intento fallback con la función personalizada
    try {
      return convertUnitsWater(value, unita, unitb);
    } catch {
      return null;
    }
  }
};

/**
 * Normaliza un valor de agua a una unidad estándar para comparación en dashboards
 * @param {number} value - Valor a normalizar
 * @param {string} unit - Unidad actual del valor
 * @param {string} targetUnit - Unidad objetivo (por defecto "m3")
 * @returns {number|null} - Valor normalizado o null si no se puede convertir
 */
export const normalizeWaterValue = (value, unit, targetUnit = "m3") => {
  // Si no hay valor, retornar 0
  if (!value || value === 0) return 0;

  // Si no hay unidad definida, asumir que ya está en la unidad objetivo
  if (!unit) return value;

  // Si la unidad es la misma, retornar valor original
  if (unit === targetUnit) return value;

  // Intentar convertir usando la función existente
  try {
    const converted = convertUnitsFinal(value, unit, targetUnit);
    return converted !== null ? converted : value;
  } catch (error) {
    console.warn(
      `No se pudo convertir de ${unit} a ${targetUnit}. Usando valor original.`,
    );
    return value;
  }
};
